import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column px-3" }
const _hoisted_2 = { class: "d-flex flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "d-flex flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_LabelContentDocumentTypeListWidget = _resolveComponent("LabelContentDocumentTypeListWidget")!
  const _component_SimpleProjectListWidget = _resolveComponent("SimpleProjectListWidget")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", null, _toDisplayString(this.caption), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Select, {
          mode: "flex",
          class: "mb-2",
          label: _ctx.$t("general.masterDataSet"),
          options: this.masterDataSetOptions,
          modelValue: this.selectedMasterDataSetId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.selectedMasterDataSetId) = $event))
        }, null, 8, ["label", "options", "modelValue"]),
        _createElementVNode("button", {
          class: "btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openRelatedProjects()))
        }, _hoisted_4)
      ]),
      _createVNode(_component_TextInput, {
        mode: "flex",
        class: "mb-2",
        label: _ctx.$t("general.description"),
        modelValue: this.selectedMasterDataSetDescription,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.selectedMasterDataSetDescription) = $event)),
        disabled: "true"
      }, null, 8, ["label", "modelValue"]),
      _createVNode(_component_LabelContentDocumentTypeListWidget, {
        docTypeEntries: this.selectedEntries
      }, null, 8, ["docTypeEntries"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.save()))
        }, _toDisplayString(_ctx.$t('general.save')), 1),
        _createElementVNode("button", {
          class: "btn btn-secondary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.abort()))
        }, _toDisplayString(_ctx.$t('general.abort')), 1)
      ])
    ]),
    _createVNode(_component_Dialog, {
      ref: "projectsDialog",
      buttons: _ctx.CLOSE,
      title: _ctx.$t('review.labelContent.relatedProjects'),
      extraClasses: ['d-flex', 'justify-content-center', 'modal-xl', 'modal-dialog-centered']
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_SimpleProjectListWidget, {
            items: this.projects
          }, null, 8, ["items"])
        ])
      ]),
      _: 1
    }, 8, ["buttons", "title"])
  ], 64))
}